export enum TrackingIndicatorEnum {
  'True' = 'T',
  'False' = 'F'
}

export namespace TrackingIndicatorEnum {
  export function values() {
    return Object.keys(TrackingIndicatorEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
